import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { SearchBarModule } from "../search-bar/search-bar.module";
import { SelectWithImagesComponent } from "./select-with-images.component";
import { RouterModule } from "@angular/router";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { SelectDropdownModule } from "../select-dropdown/select-dropdown.module";
import { SelectButtonsModule } from "../select-buttons/select-buttons.module";
import { MobileFilterComponentModule } from "../_structural/mobile-filter/mobile-filter.module";
import { ListHeaderComponentModule } from "../_structural/list-header/list-header.module";
import { ParkingFilterModule } from "../_space/space-filter/space-filter.module";

@NgModule({
  declarations: [SelectWithImagesComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    IonicModule,
    TranslateModule,
    SearchBarModule,
    RouterModule,
    SharedDirectivesModule,
    SelectDropdownModule,
    SelectButtonsModule,
    MobileFilterComponentModule,
    ListHeaderComponentModule,
    ParkingFilterModule,
  ],
  exports: [SelectWithImagesComponent],
})
export class SelectWithImagesModule {}
